import AppTitle from '@/shared/ui/AppTitle.vue';
export default {
  name: 'GrayInformationBlock',
  components: {
    AppTitle: AppTitle
  },
  props: {
    title: {
      type: String,
      default: undefined
    }
  }
};